import React from "react";
import "./PoliciesPages.scss";

const Terms = () => {
    return (
        <div className="policy-page">
            <h1>Terms & Conditions</h1>
            <p>Last updated: January 2025</p>

            <h2>1. Introduction</h2>
            <p>
                Welcome to Old Kent Shisha Lounge. By using our website or visiting our
                lounge, you agree to these Terms & Conditions.
            </p>
            <p>
                If you do not agree with any part of these Terms & Conditions, please do
                not use our website or services.
            </p>

            <h2>2. Age Restrictions</h2>
            <ul>
                <li>Entry to Old Kent Shisha Lounge is strictly 18+.</li>
                <li>
                    Valid ID must be shown upon request (passport, driving licence, or
                    government-approved photo ID).
                </li>
                <li>
                    We reserve the right to refuse entry if satisfactory ID is not
                    presented.
                </li>
            </ul>

            <h2>3. Website Use</h2>
            <ul>
                <li>Our website is provided for general information and booking purposes.</li>
                <li>You agree not to misuse or attempt to interfere with our website’s functionality.</li>
                <li>
                    All website content is owned by Old Kent Shisha Lounge and may not be
                    copied or reproduced without permission.
                </li>
            </ul>

            <h2>4. Reservations & Bookings</h2>
            <ul>
                <li>Bookings are subject to availability.</li>
                <li>We may require a deposit for large groups or special events.</li>
                <li>Deposits (where required) are non-refundable unless otherwise stated.</li>
                <li>We reserve the right to cancel or amend bookings when necessary.</li>
            </ul>

            <h2>5. Conduct Within the Lounge</h2>
            <p>For the safety and enjoyment of all guests:</p>
            <ul>
                <li>No illegal substances, outside food, or drinks are allowed.</li>
                <li>No aggressive, abusive, or antisocial behaviour.</li>
                <li>Smoking is permitted only in designated areas compliant with UK laws.</li>
                <li>We reserve the right to refuse service or remove anyone violating these rules.</li>
            </ul>

            <h2>6. Allergens, Dietary Information & Disclaimers</h2>
            <ul>
                <li>
                    Some food, drinks, or shisha flavourings may contain allergens such as nuts,
                    milk, soy, gluten, or additives.
                </li>
                <li>Customers with allergies must inform staff before ordering.</li>
                <li>We cannot guarantee any product is allergen-free.</li>
                <li>Consumption of shisha, food, or drinks is at the customer's own risk.</li>
                <li>Full allergen information is available on request.</li>
            </ul>

            <h2>7. CCTV & Surveillance Notice</h2>
            <ul>
                <li>CCTV operates throughout the venue for safety and crime prevention.</li>
                <li>Footage may be used for investigations or shared with authorities if required.</li>
                <li>Only authorised personnel may access CCTV recordings.</li>
                <li>By entering the premises, customers consent to being recorded.</li>
            </ul>

            <h2>8. Smoking / Shisha Safety Disclaimer</h2>
            <ul>
                <li>Shisha involves heated coal and equipment that can cause burns if misused.</li>
                <li>Customers must follow staff instructions at all times.</li>
                <li>Injuries caused by misuse of equipment are the customer’s responsibility.</li>
                <li>Shisha smoking poses health risks; participation is voluntary and at own risk.</li>
            </ul>

            <h2>9. Lost Property Policy</h2>
            <ul>
                <li>We are not liable for lost or stolen belongings.</li>
                <li>Items found will be held for a limited time before being disposed of.</li>
                <li>Customers should keep valuables secure at all times.</li>
            </ul>

            <h2>10. Zero-Tolerance Policy</h2>
            <ul>
                <li>Violence, threats, harassment, vandalism, or illegal activity will not be tolerated.</li>
                <li>Anyone behaving unlawfully will be removed immediately.</li>
                <li>Police may be contacted when appropriate.</li>
                <li>We reserve the right to refuse future entry to offenders.</li>
            </ul>

            <h2>11. Liability</h2>
            <ul>
                <li>We are not liable for personal belongings lost or damaged on the premises.</li>
                <li>
                    We are not responsible for service interruptions caused by events outside
                    our control (e.g., emergencies, maintenance, legal requirements).
                </li>
            </ul>

            {/* ⭐ NEW GDPR CROSS-REFERENCE SECTION ⭐ */}
            <h2>12. GDPR Compliance</h2>
            <p>
                Old Kent Shisha Lounge complies with the UK General Data Protection Regulation
                (UK GDPR) and the Data Protection Act 2018.  
                For full details on how we collect, store, protect, and manage personal data — 
                including your rights and our data breach procedures — please refer to our 
                separate GDPR Policy.
            </p>
            <p>
                You can view the GDPR Policy here: <strong>/policies/gdpr</strong>
            </p>

            <h2>13. Changes to These Terms</h2>
            <p>
                We may revise these Terms & Conditions at any time. The latest version will
                always be available on our website.
            </p>
        </div>
    );
};

export default Terms;
